import React from 'react';
import { classNames } from '../../utils/style';
import { VideoModal } from '../../layouts/VideoModal';

export const VideoMosaic = ({
  className,
  video,
  image,
  onClickVideoThumbnail,
}: any) => {
  return (
    <div className={classNames(className)}>
      {image && video && (
        <VideoModal
          image={image}
          VideoPlayer={video}
          onClick={onClickVideoThumbnail}
        />
      )}
    </div>
  );
};
